export const optionsBodyTypes = [
  "Magro",
  "Médio",
  "Musculoso",
  "Em forma",
  "Um pouco acima do peso",
  "Grande e amoroso",
];
